import { render, staticRenderFns } from "./RefreshPage.vue?vue&type=template&id=595bbf6c&"
import script from "./RefreshPage.vue?vue&type=script&lang=js&"
export * from "./RefreshPage.vue?vue&type=script&lang=js&"
import style0 from "./RefreshPage.vue?vue&type=style&index=0&id=595bbf6c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports